import React, { useState, useEffect } from 'react';
import "./css/AllProducts.css";
import { Add } from '@mui/icons-material';
import AdminProduct from './AdminProduct';
import { firestore, auth } from '../firebase';
import { useStateValue } from './StateProvider'
import { useHistory } from 'react-router-dom'

function AllProducts() {
  const history = useHistory();
  const [categoryFilter, setCategoryFilter] = useState('');
  const [priceFilter, setPriceFilter] = useState('');
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [productIds, setProductIds] = useState([]);
  const [theProducts, setTheProducts] = useState([]);
  const [{basket, user}, dispatch] = useStateValue();

  useEffect(() => {
    const userStoriesRef = firestore.collection('products');

    const unsubscribe = userStoriesRef.onSnapshot((querySnapshot) => {
      const ids = [];
      const userStoriesData = [];

      querySnapshot.forEach((doc) => {
        ids.push(doc.id);
        const data = doc.data();
        userStoriesData.push(data);
      });

      setProductIds(ids);
      setTheProducts(userStoriesData);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    const filterProduct = () => {
      const filtered = theProducts.filter((data) => {
        const categoryMatch = categoryFilter === '' || data?.productCategory === categoryFilter;

        const priceMatch =
          priceFilter === '' ||
          (priceFilter === 'at $1 - $249' && data?.productPrice > 0 && data?.productPrice < 250) ||
          (priceFilter === 'at $250 - $499' && data?.productPrice >= 250 && data?.productPrice < 500) ||
          (priceFilter === 'at $500 - $999' && data?.productPrice >= 500 && data?.productPrice < 1000) ||
          (priceFilter === 'at $1000 and above' && data?.productPrice >= 1000);

        return categoryMatch && priceMatch;
      });

      setFilteredProducts(filtered);
    };

    filterProduct();
  }, [categoryFilter, priceFilter, theProducts]);

  return (
    <div className='allproducts'>
      <div className='allproducts-box'>
        <div className="allproducts-header">
          <h1>All Your Products</h1>
          <div className='header-icons'>
            <a href='/upload-product'>
              <Add sx={{ fontSize: "30px", paddingRight: "20px", cursor: "pointer", color: "black", ":hover": { color: "orange" } }} />
            </a>
          </div>
        </div>

        <div className='filter'>
          <select onChange={(e) => setPriceFilter(e.target.value)} value={priceFilter}>
            <option value="">Select Price</option>
            <option value="at $1 - $249">$1 - $249</option>
            <option value="at $250 - $499">$250 - $499</option>
            <option value="at $500 - $999">$500 - $999</option>
            <option value="at $1000 and above">$1000 and above</option>
          </select>

          <select onChange={(e) => setCategoryFilter(e.target.value)} value={categoryFilter}>
            <option value="">Select Category</option>
            <option value="kids">Kids</option>
            <option value="workout">Workout</option>>
            <option value="electrical">Electrical</option>>
            <option value="home&accessories">Home&Accessories</option>
          </select>
        </div>

        <br />
        <div className='allproducts-row'>
          {filteredProducts.length === 0 ? (
            <span style={{ textAlign: 'left', fontFamily: 'sans-serif', paddingTop: '20px', fontWeight: 'bold' }} >
              No product found.
            </span>
          ) : (
            <>
              {filteredProducts.map((data, index) => (
                <AdminProduct key={index} data={data} productId={productIds[index]} />
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AllProducts;
